export const faqs = [
  {
    q: 'How will I receive the material?',
    a: 'The complete library is delivered digitally. Right after your purchase, you’ll receive an email with your access link and instructions to download your six volumes and five bonuses.',
  },
  {
    q: 'Are the files downloadable?',
    a: 'Yes. The library is a downloadable digital collection that you can consult from your computer, tablet, or smartphone.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. You pay $27 once. There are no monthly subscription charges for this educational library.',
  },
  {
    q: 'Is this suitable for orthodontists only?',
    a: 'The material is designed for orthodontists and qualified dental professionals studying orthodontic biomechanics and torque-control principles. It is not intended to replace formal orthodontic training.',
  },
  {
    q: 'Does this work with different clear aligner systems?',
    a: 'The library focuses on general biomechanical principles relevant to orthodontic planning. However, different aligner systems have different mechanical characteristics, capabilities, and limitations. Always evaluate the specific system you’re using.',
  },
  {
    q: 'Does the Blueprint guarantee better clinical outcomes?',
    a: 'No. The Blueprint is an educational decision-support resource. Actual orthodontic outcomes depend on individual anatomy, diagnosis, appliance mechanics, biological response, patient cooperation, and professional clinical judgment.',
  },
  {
    q: 'Can I use this material outside the United States?',
    a: 'Yes. The educational concepts are relevant internationally, and your payment is converted to your local currency automatically at checkout. Clinical practice must always follow applicable local professional standards, regulations, and patient-specific requirements.',
  },
  {
    q: 'Can I really create a torque plan in 15 minutes?',
    a: 'The included framework is organized as a 15-minute preliminary review exercise. It is designed to help you structure your thinking, not to guarantee that every clinical case can be fully assessed or planned within that time. Complex cases may require substantially more evaluation.',
  },
  {
    q: 'Does the library include clinical illustrations?',
    a: 'Yes. The collection includes biomechanical diagrams, movement illustrations, decision maps, and educational case scenarios.',
  },
  {
    q: 'Is there a money-back guarantee?',
    a: 'Yes. You have seven days after purchase to review your digital library. If it doesn’t meet your expectations, contact our support team within that period to request a refund.',
  },
];
